import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import html from "../../Assets/icon/html-5-svgrepo-com.svg";
import css from "../../Assets/icon/css-3-svgrepo-com.svg";
import bootstrap from "../../Assets/icon/bootstrap-svgrepo-com.svg";
// import tailwind from "../../Assets/icon/tailwind-svgrepo-com.svg";
// import js from "../../Assets/icon/javascript-svgrepo-com.svg";
import react from "../../Assets/icon/react-svgrepo-com.svg";
// import redux from "../../Assets/icon/redux-svgrepo-com.svg";
import mongo from "../../Assets/icon/mongodb-svgrepo-com.svg";
import node from "../../Assets/icon/node-svgrepo-com.svg";
import firebase from "../../Assets/icon/firebase-svgrepo-com.svg";
// import express from "../../Assets/icon/express-svgrepo-com.svg";
// import docker from "../../Assets/icon/docker-svgrepo-com.svg";
import github from "../../Assets/icon/github-svgrepo-com.svg"

import linktree from "../../Assets/Projects/linktree.png";
import artstore from "../../Assets/Projects/artstore.png";
import codeditor from "../../Assets/Projects/codeeditor.png";
import netflix from "../../Assets/Projects/netflix.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import certificate from "../../Assets/Projects/certificate.png";


function Projects() {
  return (
    <div id="project"
    // data-aos="zoom-out"
    // data-aos-duration="1000"
    >
      <Container fluid className="project-section">
        <Container >
          <h1 className="project-heading">
            My Recent <strong className="purple">Works </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects I've worked on recently.
          </p>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>


            <Col
              // data-aos="zoom-out"
              // data-aos-duration="1000"
              md={4} className="project-card">
              <ProjectCard
                imgPath={netflix}
                isBlog={false}
                title="Netflix Clone"
                description="A Netflix clone React project is a web application that mimics the functionality and user interface of the popular streaming service Netflix."
                ghLink="https://github.com/keshavop/Netflix-clone"
                demoLink="https://netflixclonekk.netlify.app/"
                tech1={html}
                tech2={css}
                tech3={react}
                tech4={firebase}
              />
            </Col>

            <Col
              // data-aos="zoom-out"
              // data-aos-duration="1000"
              md={4} className="project-card">
              <ProjectCard
                imgPath={codeditor}
                isBlog={false}
                title="Real Time Code-Editor"
                description="The real-time code editor React project is a web application that enables users to write, edit, and execute code in real-time."
                ghLink="https://github.com/keshavop/realtime-code-editor"
                demoLink="https://realtime-code-editor-one.vercel.app/"
                tech="https://www.svgrepo.com/show/452185/css-3.svg"
                tech1={html}
                tech2={css}
                tech3={react}
                tech4={node}
              />
            </Col>

            <Col
              // data-aos="zoom-out"
              // data-aos-duration="1000"
              md={4} className="project-card">
              <ProjectCard
                imgPath={artstore}
                isBlog={false}
                title="Art-Store"
                description="The art store React project is a web application that serves as an online marketplace for art enthusiasts."
                ghLink="https://github.com/keshavop/Capstone-Project"
                demoLink="https://keshavop.github.io/Capstone-Project/"
                tech1={html}
                tech2={css}
                tech3={react}
                tech4={github}
              />
            </Col>

            <Col
              md={4} className="project-card">
              <ProjectCard
                imgPath={certificate}
                isBlog={false}
                title="Certificate's Website"
                description="A certificate showing website is a web application that showcase certificates to acknowledge the completion of courses."
                ghLink="https://github.com/keshavop/Certificate-Website"
                demoLink="https://kkcertificatewebsite.vercel.app/"
                tech1={html}
                tech2={css}
                tech3={react}
                tech4={github}
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={portfolio}
                isBlog={false}
                title="React-Portfolio"
                description="The React portfolio is a web application that showcases a developer's skills, projects, and experiences using React.js."
                ghLink="https://github.com/keshavop/Portfolio"
                demoLink="https://github.com/keshavop/Portfolio"
                tech1={react}
                tech2={html}
                tech3={css}
                tech4={bootstrap}
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={linktree}
                isBlog={false}
                title="Linktree Clone"
                description="The Linktree clone project is a web application that provides users with a single link to access all their important links, social media profiles, and other online resources."
                ghLink="https://github.com/keshavop/linktree"
                demoLink="https://keshavlinktree.netlify.app/"
                tech1={html}
                tech2={css}
                tech3={github}
                tech4={firebase}
              />
            </Col>



          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Projects;
